// import testService from 'ApiService/Teacher/TestService';
// import DateField from 'components/fields/dateField';
// import Nodatafound from 'pages/Common/Nodatafound';
// import { formatDate } from 'pages/helpers/dateUtils';
// import { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import { BallTriangle } from 'react-loader-spinner';

// const Index = () => {
//   const [tests, setTests] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedTest, setSelectedTest] = useState(null);
//   const [filters, setFilters] = useState({
//     type: 'all',
//     createdDate: '',
//     scheduledDate: '',
//     testSchedule: '',
//   });
//   const [noData, setNoData] = useState(false);

//   const formatDateForAPI = (dateString) => {
//     if (!dateString) return undefined;

//     // Convert date string to midnight UTC to ensure consistent comparison
//     if (dateString.includes('/')) {
//       const [day, month, year] = dateString.split('/');
//       const date = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
//       return date.toISOString().split('T')[0];
//     }

//     // Handle direct date input format (YYYY-MM-DD)
//     const date = new Date(dateString);
//     date.setUTCHours(0, 0, 0, 0);
//     return date.toISOString().split('T')[0];
//   };

//   const handleFilterChange = (key, value) => {
//     if (key === 'createdDate' || key === 'scheduledDate') {
//       const formattedDate = formatDateForAPI(value);
//       console.log('Formatted date:', formattedDate);
//       setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
//     } else {
//       setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
//     }
//   };

//   const handleResetFilters = () => {
//     setFilters({
//       type: 'all',
//       createdDate: '',
//       scheduledDate: '',
//       testSchedule: '',
//     });
//     fetchTests();
//   };

//   const handleTestClick = (testItem) => {
//     setSelectedTest(testItem);
//   };

//   const handleBackClick = () => {
//     setSelectedTest(null);
//   };

//   function formatCompletionTime(minutes) {
//     if (minutes >= 60) {
//       const hours = Math.floor(minutes / 60);
//       const remainingMinutes = minutes % 60;
//       if (remainingMinutes === 0) {
//         return `${hours} hr${hours > 1 ? 's' : ''}`;
//       } else {
//         return `${hours} hr${hours > 1 ? 's' : ''} ${remainingMinutes} min`;
//       }
//     } else {
//       return `${minutes} min`;
//     }
//   }

//   const fetchTests = async () => {
//     setLoading(true);
//     setNoData(false);
//     try {
//       const formattedFilters = {
//         type: filters.type !== 'all' ? filters.type : undefined,
//         createdAt: formatDateForAPI(filters.createdDate),
//         scheduledAt: formatDateForAPI(filters.scheduledDate),
//         testSchedule: filters.testSchedule || undefined,
//       };

//       console.log('Fetching with filters:', formattedFilters);

//       const response = await testService.getAllTests(formattedFilters);

//       if (response.data.success && response.data.data.length > 0) {
//         // Filter the results on the client side as well to ensure exact matches
//         const filteredTests = response.data.data.filter((test) => {
//           const matchesCreatedDate =
//             !formattedFilters.createdAt ||
//             test.createdAt.split('T')[0] === formattedFilters.createdAt;

//           const matchesScheduledDate =
//             !formattedFilters.scheduledAt ||
//             test.scheduledAt.split('T')[0] === formattedFilters.scheduledAt;

//           return matchesCreatedDate && matchesScheduledDate;
//         });

//         setTests(filteredTests);
//         setNoData(filteredTests.length === 0);
//       } else {
//         setTests([]);
//         setNoData(true);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || 'Failed to fetch tests.');
//       setTests([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTests();
//   }, [filters]);
//   // const formatDate = (dateString) => {
//   //   const date = new Date(dateString);
//   //   const day = String(date.getUTCDate()).padStart(2, '0');
//   //   const month = String(date.getUTCMonth() + 1).padStart(2, '0');
//   //   const year = date.getUTCFullYear();
//   //   return `${day}/${month}/${year}`;
//   // };
//   const formatDate = (dateString) => {
//     if (!dateString) return 'No Date';

//     const date = new Date(dateString);
//     if (isNaN(date)) return 'No Date';

//     const day = String(date.getUTCDate()).padStart(2, '0');
//     const month = String(date.getUTCMonth() + 1).padStart(2, '0');
//     const year = date.getUTCFullYear();

//     return `${day}/${month}/${year}`;
//   };
//   return (
//     <div className="mt-4 h-full w-full rounded-[20px] md:mt-5">
//       {selectedTest ? (
//         <div className="p-4">
//           {/* Test Details View */}
//           <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
//             {selectedTest.title} - {selectedTest.type.toUpperCase()}
//           </h3>
//           <p className="text-gray-700 dark:text-gray-400">
//             Department: {selectedTest.department}
//           </p>
//           <p className="text-gray-700 dark:text-gray-400">
//             Completion Time: {formatCompletionTime(selectedTest.completionTime)}
//           </p>
//           <p className="text-gray-700 dark:text-gray-400">
//             Total Marks: {selectedTest.totalMarks}
//           </p>
//           {selectedTest.questions.map((question, qIndex) => (
//             <div
//               key={qIndex}
//               className="mt-4 rounded-lg bg-white p-4 shadow-md dark:bg-gray-800"
//             >
//               <h5 className="text-lg font-bold text-gray-900 dark:text-white">
//                 Question {qIndex + 1}: {question.questionText}
//               </h5>
//               <ul className="mt-2">
//                 {question.options.map((option, optIndex) => (
//                   <li
//                     key={optIndex}
//                     className="text-gray-700 dark:text-gray-400"
//                   >
//                     {optIndex + 1}. {option}
//                   </li>
//                 ))}
//               </ul>
//               <p className="mt-2 text-green-600 dark:text-green-400">
//                 Correct Answer: {question.correctAnswer}
//               </p>
//               {question.marks && (
//                 <p className="mt-2 text-blue-600 dark:text-blue-400">
//                   Marks: {question.marks}
//                 </p>
//               )}
//             </div>
//           ))}
//           <div className="mt-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
//             <button
//               onClick={handleBackClick}
//               className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
//             >
//               Back
//             </button>
//           </div>
//         </div>
//       ) : (
//         <>
//           {/* Filters Section */}
//           <div className="mb-4 flex flex-row space-x-4 text-navy-800">
//             <div className="w-full md:w-1/5">
//               <label className="ml-3 text-sm font-bold text-navy-800 dark:text-white">
//                 Test Type
//               </label>
//               <select
//                 value={filters.type}
//                 onChange={(e) => handleFilterChange('type', e.target.value)}
//                 className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
//               >
//                 <option value="all">All Type</option>
//                 <option value="mcq">MCQ</option>
//                 <option value="qa">QA</option>
//               </select>
//             </div>

//             <div className="w-full md:w-1/5">
//               <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
//                 Schedule Type
//               </label>
//               <select
//                 value={filters.testSchedule}
//                 onChange={(e) =>
//                   handleFilterChange('testSchedule', e.target.value)
//                 }
//                 className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
//               >
//                 <option value="">Test Schedule</option>
//                 <option value="daily">Daily</option>
//                 <option value="weekly">Weekly</option>
//                 <option value="monthly">Monthly</option>
//                 <option value="end test">End Test</option>
//               </select>
//             </div>

//             <div className="w-full md:w-1/5">
//               <DateField
//                 label="Created Date"
//                 type="date"
//                 value={filters.createdDate}
//                 onChange={(e) =>
//                   handleFilterChange('createdDate', e.target.value)
//                 }
//                 className="rounded-lg bg-gray-200 px-4 py-2 text-gray-700 dark:bg-gray-800 dark:text-gray-300"
//               />
//             </div>

//             <div className="w-full md:w-1/5">
//               <DateField
//                 label="Scheduled Date"
//                 type="date"
//                 value={filters.scheduledDate}
//                 onChange={(e) =>
//                   handleFilterChange('scheduledDate', e.target.value)
//                 }
//                 className="rounded-lg bg-gray-200 px-4 py-2 text-gray-700 dark:bg-gray-800 dark:text-gray-300"
//               />
//             </div>

//             <div className="flex w-full items-end justify-end md:w-1/5">
//               <button
//                 onClick={handleResetFilters}
//                 className="linear cursor-pointer rounded-xl bg-brand-900 px-9 py-3 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
//               >
//                 Reset Filters
//               </button>
//             </div>
//           </div>

//           {/* Tests List Section */}
//           {loading ? (
//             <div className="flex h-40 items-center justify-center">
//               <BallTriangle color="#5431ed" />
//             </div>
//           ) : noData ? (
//             <div className="flex  items-center justify-center dark:text-gray-600">
//               <Nodatafound title="No tests found" />
//             </div>
//           ) : (
//             <div className="grid h-full max-h-[68vh] w-full grid-cols-1 gap-4 overflow-hidden overflow-y-scroll rounded-xl border border border-gray-200 p-2 dark:border-white/10 md:grid-cols-2 lg:grid-cols-3">
//               {tests.map((test, i) => {
//                 const uniqueAssignedTo = Array.from(
//                   new Map(
//                     test.assignedTo.map((item) => [
//                       `${item._id}-${item.batchNumber}`,
//                       item,
//                     ])
//                   ).values()
//                 ).sort((a, b) => a.batchNumber - b.batchNumber);

//                 return (
//                   <div
//                     key={test._id}
//                     onClick={() => handleTestClick(test)}
//                     className="cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none hover:border-brand-500 dark:border-[#323B5D] dark:!bg-navy-900 dark:bg-navy-900 dark:text-white"
//                   >
//                     <div className="w-full p-4">
//                       <h5 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white">
//                         {i + 1}. {test.title}
//                       </h5>
//                       <h6 className="mb-2 text-sm font-bold text-gray-900 dark:text-white">
//                         Assigned To Batch:{' '}
//                         {uniqueAssignedTo.length > 0
//                           ? uniqueAssignedTo.map(
//                               (item, index) =>
//                                 `${item.batchNumber}${
//                                   index < uniqueAssignedTo.length - 1
//                                     ? ', '
//                                     : ''
//                                 }`
//                             )
//                           : 'Not Assigned'}
//                       </h6>
//                       <p className="font-normal text-gray-700 dark:text-gray-400">
//                         Course: {test.department}
//                       </p>
//                       <p className="font-normal text-gray-700 dark:text-gray-400">
//                         Test Type: {test.type}
//                       </p>
//                       <p className="font-normal text-gray-700 dark:text-gray-400">
//                         Test Schedule:{' '}
//                         {test.testSchedule || 'Not Scheduled Yet'}
//                       </p>
//                       <p className="font-normal text-gray-700 dark:text-gray-400">
//                         Created At: {formatDate(test.createdAt || 'N/A')}
//                       </p>
//                       <p className="font-normal text-gray-700 dark:text-gray-400">
//                         Scheduled At: {formatDate(test?.scheduledAt || 'N/A')}
//                       </p>
//                       <p className="font-normal text-gray-700 dark:text-gray-400">
//                         Total Questions: {test.questions.length}
//                       </p>
//                       <p className="font-normal text-gray-700 dark:text-gray-400">
//                         Completion Time:{' '}
//                         {formatCompletionTime(test.completionTime)}
//                       </p>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default Index;

import testService from 'ApiService/Teacher/TestService';
import DateField from 'components/fields/dateField';
import Nodatafound from 'pages/Common/Nodatafound';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';

const Index = () => {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTest, setSelectedTest] = useState(null);
  const [noData, setNoData] = useState(false);

  const [filterCourseName, setFilterCourseName] = useState('');
  const [filterBatch, setFilterBatch] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [filterCreatedBy, setFilterCreatedBy] = useState('');
  const [uniqueCourses, setUniqueCourses] = useState([]);
  const [uniqueBatches, setUniqueBatches] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [uniqueCreators, setUniqueCreators] = useState([]);

  const [filters, setFilters] = useState({
    type: 'all',
    createdDate: '',
    scheduledDate: '',
  });

  const formatDateForAPI = (dateString) => {
    if (!dateString) return undefined;
    if (dateString.includes('/')) {
      const [day, month, year] = dateString.split('/');
      const date = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
      return date.toISOString().split('T')[0];
    }
    const date = new Date(dateString);
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString().split('T')[0];
  };

  const handleFilterChange = (key, value) => {
    if (key === 'createdDate' || key === 'scheduledDate') {
      setFilters((prev) => ({ ...prev, [key]: value }));
    } else {
      setFilters((prev) => ({ ...prev, [key]: value }));
    }
  };

  const handleResetFilters = () => {
    setFilters({
      type: 'all',
      createdDate: '',
      scheduledDate: '',
    });
    setFilterCourseName('');
    setFilterBatch('');
    setFilterCreatedBy('');
    fetchTests();
  };

  const handleTestClick = (testItem) => {
    setSelectedTest(testItem);
  };

  const handleBackClick = () => {
    setSelectedTest(null);
  };

  function formatCompletionTime(minutes) {
    if (minutes >= 60) {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return remainingMinutes === 0
        ? `${hours} hr${hours > 1 ? 's' : ''}`
        : `${hours} hr${hours > 1 ? 's' : ''} ${remainingMinutes} min`;
    } else {
      return `${minutes} min`;
    }
  }

  const fetchTests = async () => {
    setLoading(true);
    setNoData(false);
    try {
      const formattedFilters = {
        type: filters.type !== 'all' ? filters.type : undefined,
        createdAt: formatDateForAPI(filters.createdDate),
        scheduledAt: formatDateForAPI(filters.scheduledDate),
      };

      const response = await testService.getAllTests(formattedFilters);

      if (response.data.success && response.data.data.length > 0) {
        const filteredTests = response.data.data.filter((test) => {
          const matchesCreatedDate =
            !formattedFilters.createdAt ||
            test.createdAt.split('T')[0] === formattedFilters.createdAt;
          const matchesScheduledDate =
            !formattedFilters.scheduledAt ||
            test.scheduledAt.split('T')[0] === formattedFilters.scheduledAt;
          return matchesCreatedDate && matchesScheduledDate;
        });

        setTests(filteredTests);
        setNoData(filteredTests.length === 0);
      } else {
        setTests([]);
        setNoData(true);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch tests.');
      setTests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTests();
  }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

  // ✅ Extract unique course names when tests change
  useEffect(() => {
    if (tests.length > 0) {
      const courses = [
        ...new Set(
          tests.flatMap((t) =>
            t.batchStructure?.courses?.map((c) => c.courseName).filter(Boolean) || []
          )
        ),
      ];
      setUniqueCourses(courses);

      const creators = [
        ...new Set(tests.map((t) => t.createdBy?.name).filter(Boolean)),
      ];
      setUniqueCreators(creators);
    }
  }, [tests]);

  // ✅ Extract unique batches when course changes
  useEffect(() => {
    if (tests.length > 0) {
      let filtered = tests;
      if (filterCourseName) {
        filtered = tests.filter(
          (t) => t.batchStructure?.courses?.some((c) => c.courseName === filterCourseName)
        );
      }
      const batches = [
        ...new Set(
          filtered.flatMap(
            (t) =>
              t.assignedTo
                ?.filter((b) => b?._id && b.startDate && b.endDate)
                .map((b) => {
                  // Extract all start times from daySchedules and remove duplicates
                  const uniqueTimes = [
                    ...new Set(
                      b.daySchedules?.map((ds) => ds.startTime).filter(Boolean) // remove empty times
                    ),
                  ];

                  // Join times with " / " if multiple
                  const timeDisplay =
                    uniqueTimes.length > 0
                      ? ` at ${uniqueTimes.join(' / ')}`
                      : '';

                  return `${b._id}::B${b.batchNumber} (${new Date(
                    b.startDate
                  ).toLocaleDateString()}-${new Date(
                    b.endDate
                  ).toLocaleDateString()}${timeDisplay})`;
                }) || []
          )
        ),
      ];

      // const batches = [
      //   ...new Set(
      //     filtered.flatMap(
      //       (t) =>
      //         t.assignedTo?.map(
      //           (b) =>
      //             `${b._id}::Batch ${b.batchNumber} (${new Date(
      //               b.startDate
      //             ).toLocaleDateString()} to ${new Date(
      //               b.endDate
      //             ).toLocaleDateString()})`
      //         ) || []
      //     )
      //   ),
      // ];
      setUniqueBatches(batches.sort());
      setFilterBatch('');
    }
  }, [filterCourseName, tests]);

  const formatDateDisplay = (dateString) => {
    if (!dateString) return 'No Date';
    const date = new Date(dateString);
    if (isNaN(date)) return 'No Date';
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="mt-4 h-full w-full rounded-[20px] md:mt-5">
      {selectedTest ? (
        <div className="p-4">
          {/* Test Details View */}
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
            {selectedTest.title} - {selectedTest.type.toUpperCase()}
          </h3>
          <p className="text-gray-700 dark:text-gray-400">
            Department: {selectedTest.department}
          </p>
          <p className="text-gray-700 dark:text-gray-400">
            Completion Time: {formatCompletionTime(selectedTest.completionTime)}
          </p>
          <p className="text-gray-700 dark:text-gray-400">
            Total Marks: {selectedTest.totalMarks}
          </p>

          {selectedTest.questions.map((question, qIndex) => (
            <div
              key={qIndex}
              className="mt-4 rounded-lg bg-white p-4 shadow-md dark:bg-gray-800"
            >
              <h5 className="text-lg font-bold text-gray-900 dark:text-white">
                Question {qIndex + 1}: {question.questionText}
              </h5>
              <ul className="mt-2">
                {question.options.map((option, optIndex) => (
                  <li
                    key={optIndex}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    {optIndex + 1}. {option}
                  </li>
                ))}
              </ul>
              <p className="mt-2 text-green-600 dark:text-green-400">
                Correct Answer: {question.correctAnswer}
              </p>
              {question.marks && (
                <p className="mt-2 text-blue-600 dark:text-blue-400">
                  Marks: {question.marks}
                </p>
              )}
            </div>
          ))}
          <div className="mt-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
            <button
              onClick={handleBackClick}
              className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
            >
              Back
            </button>
          </div>
        </div>
      ) : (
        <>
          {/* ✅ Filters Section with Course & Batch */}
          <div className="mb-4 flex flex-col gap-4 md:flex-row md:items-center">
            {/* Course Name Filter */}
            <div className="w-full md:w-1/6">
              <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                Course Name
              </label>
              <select
                value={filterCourseName}
                onChange={(e) => setFilterCourseName(e.target.value)}
                className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm outline-none dark:bg-navy-800 dark:text-white"
              >
                <option value="">All Courses</option>
                {uniqueCourses.map((course, i) => (
                  <option key={i} value={course}>
                    {course}
                  </option>
                ))}
              </select>
            </div>

            {/* Created By Filter */}
            <div className="w-full md:w-1/6">
              <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                Created By
              </label>
              <select
                value={filterCreatedBy}
                onChange={(e) => setFilterCreatedBy(e.target.value)}
                className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm outline-none dark:bg-navy-800 dark:text-white"
              >
                <option value="">All Teachers</option>
                {uniqueCreators.map((name, i) => (
                  <option key={i} value={name}>{name}</option>
                ))}
              </select>
            </div>

            {/* Batch Filter */}
            <div className="w-full md:w-1/6">
              <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                Batch
              </label>
              <select
                value={filterBatch}
                onChange={(e) => setFilterBatch(e.target.value)}
                disabled={!filterCourseName}
                className={`mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm outline-none dark:bg-navy-800 dark:text-white ${
                  !filterCourseName ? 'cursor-not-allowed bg-gray-100' : ''
                }`}
              >
                <option value="">All Batches</option>

                {uniqueBatches.map((batchStr) => {
                  const [id, label] = batchStr.split('::');
                  return (
                    <option key={id} value={id}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </div>

            {/* Existing Filters */}
            <div className="w-full md:w-1/6">
              <label className="ml-3 text-sm font-bold text-navy-800 dark:text-white">
                Test Type
              </label>
              <select
                value={filters.type}
                onChange={(e) => handleFilterChange('type', e.target.value)}
                className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
              >
                <option value="all">All Type</option>
                <option value="mcq">MCQ</option>
                <option value="qa">QA</option>
              </select>
            </div>



            <div className="w-full md:w-1/6">
              <DateField
                label="Created Date"
                type="date"
                value={filters.createdDate}
                onChange={(e) =>
                  handleFilterChange('createdDate', e.target.value)
                }
              />
            </div>

            <div className="w-full md:w-1/6">
              <DateField
                label="Scheduled Date"
                type="date"
                value={filters.scheduledDate}
                onChange={(e) =>
                  handleFilterChange('scheduledDate', e.target.value)
                }
              />
            </div>

            <div className="flex w-full items-end justify-end md:w-1/6">
              <button
                onClick={handleResetFilters}
                className="linear cursor-pointer rounded-xl bg-brand-900 px-9 py-3 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
              >
                Reset Filters
              </button>
            </div>
          </div>

          {/* Tests List Section */}
          {loading ? (
            <div className="flex h-40 items-center justify-center">
              <BallTriangle color="#5431ed" />
            </div>
          ) : noData ? (
            <div className="flex items-center justify-center dark:text-gray-600">
              <Nodatafound title="No tests found" />
            </div>
          ) : (
            <div className="grid h-full max-h-[68vh] w-full grid-cols-1 gap-4 overflow-hidden overflow-y-scroll rounded-xl border border-gray-200 p-2 dark:border-white/10 md:grid-cols-2 lg:grid-cols-3">
              {tests
                .filter((test) => {
                  // ✅ Client-side filtering based on course and batch
                  const matchCourse =
                    !filterCourseName ||
                    test.batchStructure?.courses?.some((c) => c.courseName === filterCourseName);
                  const matchBatch =
                    !filterBatch ||
                    test.assignedTo?.some((b) => b._id === filterBatch);
                  const matchCreator =
                    !filterCreatedBy ||
                    test.createdBy?.name === filterCreatedBy;
                  return matchCourse && matchBatch && matchCreator;
                })
                .map((test, i) => {
                  const uniqueAssignedTo = Array.from(
                    new Map(
                      test.assignedTo.map((item) => [
                        `${item._id}-${item.batchNumber}`,
                        item,
                      ])
                    ).values()
                  ).sort((a, b) => a.batchNumber - b.batchNumber);

                  return (
                    <div
                      key={test._id}
                      onClick={() => handleTestClick(test)}
                      className="cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none hover:border-brand-500 dark:border-[#323B5D]  dark:bg-navy-900 dark:text-white"
                    >
                      <div className="w-full p-4">
                        <h5 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white">
                          {i + 1}. {test.title}
                        </h5>
                        <h6 className="mb-2 text-sm font-bold text-gray-900 dark:text-white">
                          Assigned To Batch:{' '}
                          {uniqueAssignedTo.length > 0
                            ? uniqueAssignedTo
                                .map((b) => b.batchNumber)
                                .join(', ')
                            : 'Not Assigned'}
                        </h6>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                          Course: {test.batchStructure?.courses?.map((c) => c.courseName).filter(Boolean).join(', ') || 'N/A'}
                        </p>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                          Test Type: {test.type}
                        </p>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                          Created by: {test.createdBy?.name || 'Unknown'}
                        </p>

                        <p className="font-normal text-gray-700 dark:text-gray-400">
                          Created At: {formatDateDisplay(test.createdAt)}
                        </p>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                          Scheduled At: {formatDateDisplay(test.scheduledAt)}
                        </p>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                          Total Questions: {test.questions.length}
                        </p>
                        <p className="font-normal text-gray-700 dark:text-gray-400">
                          Completion Time:{' '}
                          {formatCompletionTime(test.completionTime)}
                        </p>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Index;
